<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <FormPlace
          :data="place"
          :cities="cities"
          :loading="isFormLoading"
          :isNew="!id"
          :language="language"
          @submit="placeSubmitHandle"
          @cancel="$router.push({ name: 'page-places' })"
          @delete-place="deletePlace"
          @language-update="language = $event"
        />
      </v-col>
    </v-row>
    <ConfirmationDialog ref="confirmPlaceRemoving" confirmText="Удалить" />
  </v-container>
</template>

<script>
import ConfirmationDialog from '@/components/confirmation-dialog'
import FormPlace from '@/pages/place/form/FormPlace.vue'
import placeQuery from '@/services/gql/types/Places/queries/place.gql'
import updatePlaceMutation from '@/services/gql/types/Places/mutations/updatePlace.gql'
import createPlaceMutation from '@/services/gql/types/Places/mutations/createPlace.gql'
import deletePlaceMutation from '@/services/gql/types/Places/mutations/deletePlace.gql'
import citiesQuery from '@/services/gql/types/City/queries/citiesGrid.gql'
import { contentLocales, contentLocalesValues } from '@/configs/locales'
import { getListWithNewMainLanguage, setTranslation } from '@/utils/locales'
export default {
  name: 'PagePlace',
  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },
  components: {
    FormPlace,
    ConfirmationDialog
  },
  metaInfo () {
    return {
      title: this.id ? 'Редактировать место' : 'Создать место'
    }
  },
  computed: {
    isFormLoading () {
      return (
        this.$apollo.queries.place.loading ||
        this.$async.createPlace.$pending ||
        this.$async.updatePlace.$pending
      )
    }
  },
  data () {
    return {
      language: contentLocales[0].value,
      place: {},
      cities: null
    }
  },
  methods: {
    async deletePlace () {
      try {
        await this.$refs.confirmPlaceRemoving.open()
        await this.$async.deletePlace.$perform({ id: this.id })
        this.$successMsg('Место удалено')
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(e.graphQLErrors, `Ошибка при удалении места с ID ${this.id}`)
      } finally {
        await this.$router.push({ name: 'page-places' })
      }
    },
    placeSubmitHandle (placePayload) {
      if (this.id) this.updatePlace(placePayload)
      else this.createPlace(placePayload)
    },
    async createPlace ({ data }) {
      try {
        delete data.translations
        await this.$async.createPlace.$perform({
          data
        })
        this.$successMsg('Место создано')
        this.$emit('updated')
        await this.$router.push({ name: 'page-places' })
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при создании места')
      }
    },
    async updatePlace ({ data }) {
      try {
        setTranslation(data, this.language)
        await this.$async.updatePlace.$perform(
          {
            id: Number(this.id),
            data
          },
          { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) }
        )
        this.$successMsg('Место обновлено')
        this.$emit('updated')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при обновлении места')
      }
    }
  },
  apollo: {
    place: {
      fetchPolicy: 'network-only',
      query: placeQuery,
      skip () {
        return !this.id
      },
      variables () {
        return {
          where: {
            id: Number(this.id)
          }
        }
      },
      context () {
        return {
          headers: {
            Language: getListWithNewMainLanguage(this.language, contentLocalesValues())
          }
        }
      },
      result (res) {
        if (res.data === undefined) {
          this.$handleApiError(res.error)
          this.$router.push({ name: 'page-places' })
        } else {
          this.place = res.data?.place
        }
      }
    },
    cities: {
      query: citiesQuery,
      fetchPolicy: 'network-only',
      pollInterval: 30000,
      variables: {
        where: {
          status_not: 'DRAFT'
        }
      },
      result (res) {
        if (res.data === undefined) {
          this.$handleApiError(res.error)
          this.$router.push({ name: 'page-events' })
        } else {
          this.cities =
            res?.data?.cities?.list.map(city => ({
              id: city.id,
              title: city.title
            })) || []
        }
      }
    }
  },
  async: {
    deletePlace (variables) {
      return this.$apollo.mutate({
        mutation: deletePlaceMutation,
        variables
      })
    },
    createPlace (variables) {
      return this.$apollo.mutate({
        mutation: createPlaceMutation,
        variables
      })
    },
    updatePlace (variables, headers) {
      return this.$apollo.mutate({
        mutation: updatePlaceMutation,
        variables,
        context: {
          headers
        }
      })
    }
  }
}
</script>
